export default __webpack_public_path__ + "static/media/logo-v.26f7d866.png";